import { PdrType } from '../models/request-and-responses/rest-api/enums/pdrType';

interface IPdrTypeObject {
    id: PdrType;
    label: string;
}

export const PdrTypeObjects: IPdrTypeObject[] = [
    {
        id: PdrType.Domestic,
        label: 'Cliente domestico'
    },
    {
        id: PdrType.Public,
        label: 'Servizio pubblico'
    },
    {
        id: PdrType.DifferentUsages,
        label: 'Usi diversi'
    },
    {
        id: PdrType.Condominium,
        label: 'Condominio con uso domestico'
    }
];



// WEBPACK FOOTER //
// ./src/app/helpers/pdrTypeObjects.ts